const mapDisplayModes = [0, 1, 2]
export const [MAP_CLOSED, MAP_DISPLAYED, MAP_EXPANDED] = mapDisplayModes
